// Path: ./src/contextApi/reducer.ts
import { AdminUser, GoFlyerAdminState } from "./state";

import {
  ActionType,
  GoFlyerAdminActions,
  SetFlyerItemCategories,
  SetGfAdminUser,
  SetPromotionTags,
  SetTest,
  SetUnits,
  SetUser,
  SetAdvancedSearchKeepSearchResults,
  SetAdvancedSearchSearchLimit,
  SetAdvancedSearchSearchFlyerItems,
} from "./actions";
import {
  GfAdminUser,
  GfFlyerItemCategory,
  GfPromotionTag,
  GfUnit,
} from "@swagger/typescript-fetch-goflyer";

export function goFlyerAdminReducer(
  state: GoFlyerAdminState,
  action: GoFlyerAdminActions,
): GoFlyerAdminState {
  switch (action.type) {
    case ActionType.SetTest:
      return { ...state, test: action.payload };

    case ActionType.SetUser:
      if (action.payload) {
        return { ...state, user: { ...state.user, ...action.payload } };
      } else {
        return { ...state, user: undefined };
      }

    case ActionType.SetGfAdminUser:
      if (action.payload) {
        return { ...state, gfAdminUser: action.payload };
      } else {
        return { ...state, gfAdminUser: undefined };
      }

    case ActionType.SetPromotionTags:
      return { ...state, promotionTags: action.payload };

    case ActionType.SetFlyerItemCategories:
      return { ...state, flyerItemCategories: action.payload };

    case ActionType.SetUnits:
      return { ...state, units: action.payload };

    case ActionType.SetAdvancedSearchKeepSearchResults:
      return {
        ...state,
        advancedSearchPreferences: {
          ...state.advancedSearchPreferences,
          keepSearchResults: action.payload,
        },
      };

    case ActionType.SetAdvancedSearchSearchLimit:
      return {
        ...state,
        advancedSearchPreferences: {
          ...state.advancedSearchPreferences,
          searchLimit: action.payload,
        },
      };

    case ActionType.SetAdvancedSearchSearchFlyerItems:
      return {
        ...state,
        advancedSearchPreferences: {
          ...state.advancedSearchPreferences,
          searchFlyerItems: action.payload,
        },
      };

    default:
      return state;
  }
}

// helper functions to simplify the caller
export const setTest = (test: boolean): SetTest => {
  return {
    type: ActionType.SetTest,
    payload: test,
  };
};

export const setUser = (adminUser: AdminUser | undefined): SetUser => {
  if (!adminUser) {
    return {
      type: ActionType.SetUser,
      payload: undefined,
    };
  }

  return {
    type: ActionType.SetUser,
    payload: {
      ...adminUser,
    },
  };
};

/**
 * in the near future, setUser will be replace with setGfAdminUser
 * @param adminUser
 * @returns
 */
export const setGfAdminUser = (
  adminUser: GfAdminUser | undefined,
): SetGfAdminUser => {
  if (!adminUser) {
    return {
      type: ActionType.SetGfAdminUser,
      payload: undefined,
    };
  }
  console.log("adminUser", adminUser);
  return {
    type: ActionType.SetGfAdminUser,
    payload: {
      ...adminUser,
      settings: [...(adminUser.settings || [])],
    },
  };
};

export const setPromotionTags = (
  promotionTags: GfPromotionTag[] | undefined,
): SetPromotionTags => {
  return {
    type: ActionType.SetPromotionTags,
    payload: promotionTags,
  };
};

export const setFlyerItemCategories = (
  flyerItemCategories: GfFlyerItemCategory[] | undefined,
): SetFlyerItemCategories => {
  return {
    type: ActionType.SetFlyerItemCategories,
    payload: flyerItemCategories,
  };
};

export const setUnits = (units: GfUnit[] | undefined): SetUnits => {
  return {
    type: ActionType.SetUnits,
    payload: units,
  };
};

export const setAdvancedSearchKeepSearchResults = (
  keep: boolean,
): SetAdvancedSearchKeepSearchResults => {
  return {
    type: ActionType.SetAdvancedSearchKeepSearchResults,
    payload: keep,
  };
};

export const setAdvancedSearchSearchLimit = (
  limit: number,
): SetAdvancedSearchSearchLimit => {
  return {
    type: ActionType.SetAdvancedSearchSearchLimit,
    payload: limit,
  };
};

export const setAdvancedSearchSearchFlyerItems = (
  search: boolean,
): SetAdvancedSearchSearchFlyerItems => {
  return {
    type: ActionType.SetAdvancedSearchSearchFlyerItems,
    payload: search,
  };
};
